import React, { ComponentProps } from 'react';

interface Props {
    rightContent?: React.ReactNode;
    leftContent?: React.ReactNode;
    reversed?: boolean;
}

type SectionProps = Props & ComponentProps<'section'>;

export const SlicedBarSection: React.FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<SectionProps>>
> = ({ leftContent, rightContent, reversed = false, className = '', ...props }) => {
    const baseBarClass = 'tw-absolute tw-inset-0 tw-h-[20vh] tw-flex tw-justify-center tw-items-start tw-flex-col';

    return (
        <section className={`tw-relative tw-mt-[5vh] tw-h-[25vh] ${className}`} {...props}>
            <div
                className="tw-pointer-events-none tw-absolute tw-top-[-80vh] tw-z-[1] tw-h-[80vh] tw-w-full tw-bg-successLight tw-opacity-30"
                style={{
                    clipPath: reversed
                        ? 'polygon(100% 0, 100% 0, 100% 100%, 60% 100%)'
                        : 'polygon(0 0, 0 0, 40% 100%, 0% 100%)'
                }}
            />

            <div
                className={`${baseBarClass} ${
                    reversed
                        ? `tw-z-0 tw-bg-successLight tw-pb-8 tw-pl-8 tw-pr-[53%] tw-pt-8 tw-text-left md:tw-pb-12 md:tw-pl-12 md:tw-pr-[50%] md:tw-pt-12`
                        : `tw-z-[1] tw-bg-transparent tw-pb-8 tw-pl-8 tw-pr-[60%] tw-pt-8 md:tw-pb-12 md:tw-pl-12 md:tw-pr-[60%] md:tw-pt-12`
                }`}
                style={{
                    clipPath: reversed
                        ? 'polygon(0 0, 60% 0, 50% 100%, 0 100%)'
                        : 'polygon(0 0, 40% 0, 50% 100%, 0% 100%)'
                }}
            >
                {leftContent}
            </div>

            <div
                className={`${baseBarClass} ${
                    reversed
                        ? `tw-z-[1] tw-bg-transparent tw-pb-8 tw-pl-[60%] tw-pr-8 tw-pt-8 tw-text-left md:tw-pb-12 md:tw-pl-[60%] md:tw-pr-12 md:tw-pt-12`
                        : `tw-z-[1] tw-bg-successLight tw-pb-8 tw-pl-[55%] tw-pr-8 tw-pt-8 md:tw-pb-12 md:tw-pl-[55%] md:tw-pr-12 md:tw-pt-12`
                }`}
                style={{
                    clipPath: reversed
                        ? 'polygon(60% 0, 100% 0, 100% 100%, 50% 100%)'
                        : 'polygon(40% 0, 100% 0, 100% 100%, 50% 100%)'
                }}
            >
                {rightContent}
            </div>
        </section>
    );
};
